const pickUpAndReturn = require('@/apps/pick_up_and_return/api/pickUpAndReturn');

let api = {};

Object.assign(api, pickUpAndReturn.default)

export default api;
